/**
 * 事件消息
 */
export enum WeappBridgeMessage {
  isReady = 'Are You OK?',
  ready = 'I`m OK!',
  ping = 'ping',
  pong = 'pong',
  alive = 'I`m alive!',
}
